module.exports = __webpack_public_path__ + "static/media/group-biz-insight.7ce5a5b9.svg";